import React, { useState, useEffect, useRef } from 'react';
import api, { getUploadUrl } from '../../services/api';

const empty = { titulo: '', link: '', ordem: '0', data_inicio: '', data_fim: '' };

export default function AdminBanner() {
  const [banners, setBanners] = useState([]);
  const [form, setForm] = useState(empty);
  const [editando, setEditando] = useState(null);
  const [imagemFile, setImagemFile] = useState(null);
  const [imagemPreview, setImagemPreview] = useState(null);
  const [msg, setMsg] = useState('');
  const fileRef = useRef(null);

  useEffect(() => { carregar(); }, []);
  function carregar() { api.get('/banners/admin').then(setBanners).catch(() => {}); }

  function set(field) { return e => setForm(f => ({ ...f, [field]: e.target.value })); }

  function handleImagem(e) {
    const file = e.target.files[0];
    if (!file) return;
    setImagemFile(file);
    setImagemPreview(URL.createObjectURL(file));
  }

  function limparImagem() {
    setImagemFile(null);
    setImagemPreview(null);
    if (fileRef.current) fileRef.current.value = '';
  }

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      const fd = new FormData();
      fd.append('titulo', form.titulo);
      fd.append('link', form.link);
      fd.append('ordem', form.ordem || '0');
      fd.append('data_inicio', form.data_inicio);
      fd.append('data_fim', form.data_fim);
      if (imagemFile) fd.append('imagem', imagemFile);

      if (editando) {
        fd.append('ativo', editando.ativo ? '1' : '0');
        await api.uploadPut(`/banners/${editando.id}`, fd);
      } else {
        if (!imagemFile) { setMsg('A imagem do banner é obrigatória.'); return; }
        await api.upload('/banners', fd);
      }
      setMsg('Salvo com sucesso!');
      setForm(empty); setEditando(null); limparImagem(); carregar();
    } catch (err) { setMsg(err.message); }
  }

  async function deletar(id) {
    if (!window.confirm('Remover banner?')) return;
    await api.delete(`/banners/${id}`); carregar();
  }

  async function alternarAtivo(b) {
    const fd = new FormData();
    fd.append('titulo', b.titulo || '');
    fd.append('link', b.link || '');
    fd.append('ordem', b.ordem);
    fd.append('data_inicio', b.data_inicio ? b.data_inicio.slice(0, 10) : '');
    fd.append('data_fim', b.data_fim ? b.data_fim.slice(0, 10) : '');
    fd.append('ativo', b.ativo ? '0' : '1');
    await api.uploadPut(`/banners/${b.id}`, fd);
    carregar();
  }

  function iniciarEdicao(b) {
    setEditando(b);
    setForm({
      titulo: b.titulo || '',
      link: b.link || '',
      ordem: String(b.ordem),
      data_inicio: b.data_inicio ? b.data_inicio.slice(0, 10) : '',
      data_fim: b.data_fim ? b.data_fim.slice(0, 10) : '',
    });
    limparImagem();
  }

  function cancelar() {
    setEditando(null);
    setForm(empty);
    limparImagem();
  }

  const previewSrc = imagemPreview || (editando?.imagem ? getUploadUrl(editando.imagem) : null);

  return (
    <div>
      <h2 className="admin-title">Banner da Home</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      <form onSubmit={salvar} className="admin-form">
        <h3>{editando ? 'Editar Banner' : 'Novo Banner'}</h3>
        <div className="form-row">
          <div className="form-group"><label>Título (opcional)</label><input value={form.titulo} onChange={set('titulo')} /></div>
          <div className="form-group"><label>Link de destino (opcional)</label><input value={form.link} onChange={set('link')} placeholder="https://..." /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Ordem de exibição</label><input type="number" min="0" value={form.ordem} onChange={set('ordem')} /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Data Início (opcional)</label><input type="date" value={form.data_inicio} onChange={set('data_inicio')} /></div>
          <div className="form-group"><label>Data Fim (opcional)</label><input type="date" value={form.data_fim} onChange={set('data_fim')} /></div>
        </div>
        <div className="form-group">
          <label>Imagem do Banner</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {previewSrc && (
              <img
                src={previewSrc}
                alt="Prévia"
                style={{ width: 120, height: 48, objectFit: 'cover', borderRadius: 8, border: '1px solid var(--border)', flexShrink: 0 }}
              />
            )}
            <input ref={fileRef} type="file" accept="image/*" onChange={handleImagem} style={{ flex: 1 }} />
          </div>
          {imagemFile && (
            <button type="button" onClick={limparImagem} style={{ marginTop: 6, fontSize: 12, color: 'var(--danger)', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
              ✕ Remover imagem selecionada
            </button>
          )}
        </div>
        <div className="admin-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          {editando && <button type="button" className="btn btn-secondary" onClick={cancelar}>Cancelar</button>}
        </div>
      </form>
      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr><th>Imagem</th><th>Título</th><th>Ordem</th><th>Período</th><th>Ativo</th><th>Ações</th></tr>
          </thead>
          <tbody>
            {banners.map(b => (
              <tr key={b.id}>
                <td><img src={getUploadUrl(b.imagem)} alt={b.titulo || 'Banner'} style={{ width: 70, height: 30, objectFit: 'cover', borderRadius: 6 }} /></td>
                <td>{b.titulo || <span style={{ color: 'var(--text2)' }}>—</span>}</td>
                <td>{b.ordem}</td>
                <td style={{ fontSize: 12, color: 'var(--text2)' }}>
                  {b.data_inicio ? b.data_inicio.slice(0, 10) : '—'} até {b.data_fim ? b.data_fim.slice(0, 10) : '—'}
                </td>
                <td>{b.ativo ? <span className="badge badge-success">Sim</span> : <span className="badge badge-danger">Não</span>}</td>
                <td>
                  <div className="admin-actions">
                    <button className="btn btn-secondary" onClick={() => iniciarEdicao(b)}>Editar</button>
                    <button className={b.ativo ? 'btn btn-danger' : 'btn btn-success'} onClick={() => alternarAtivo(b)}>
                      {b.ativo ? 'Inativar' : 'Ativar'}
                    </button>
                    <button className="btn btn-danger" onClick={() => deletar(b.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
            {banners.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text2)', padding: 20 }}>Nenhum banner cadastrado.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
